import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import toast from "react-hot-toast";

const ProtectedRoute = ({ children, role }) => {
  const { user, loading, getRedirectPath } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-slate-600"></div>
      </div>
    );
  }

  if (!user) {
    // Store the intended URL in location state for redirect after login
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }

  // Check role-based access
  if (role) {
    const allowedRoles = Array.isArray(role) ? role : [role];

    // Super admin can access any role-protected route
    if (user.role === "super_admin") {
      // Allow super admin through
    } else if (!allowedRoles.includes(user.role)) {
      // User is authenticated but doesn't have the required role — redirect to their dashboard
      const dashboardPath = getRedirectPath(user);
      return <Navigate to={dashboardPath} replace />;
    }
  }

  // Check club-specific access
  const currentPath = location.pathname;
  const correctPath = getRedirectPath(user, currentPath);

  // If the user should be redirected to a different path, do so
  if (correctPath !== currentPath) {
    // Check if this is a club access issue for non-super admin users
    const clubMatch = currentPath.match(/^\/portal\/club\/([^/]+)/);
    if (
      clubMatch &&
      correctPath.includes("/portal/club/") &&
      user.role !== "super_admin"
    ) {
      toast.error(
        "You don't have access to this club. Redirected to your club.",
      );
    }
    return <Navigate to={correctPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
